import { render, staticRenderFns } from "./DataHistory.vue?vue&type=template&id=feb7e6ea&"
import script from "./DataHistory.vue?vue&type=script&lang=js&"
export * from "./DataHistory.vue?vue&type=script&lang=js&"
import style0 from "./DataHistory.vue?vue&type=style&index=0&id=feb7e6ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports